import { render, staticRenderFns } from "./ncdc.vue?vue&type=template&id=2bf75904&scoped=true"
import script from "./ncdc.vue?vue&type=script&lang=js"
export * from "./ncdc.vue?vue&type=script&lang=js"
import style0 from "./ncdc.vue?vue&type=style&index=0&id=2bf75904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf75904",
  null
  
)

export default component.exports